import { render, staticRenderFns } from "./ChatImage.vue?vue&type=template&id=72791d0a&scoped=true&"
import script from "./ChatImage.vue?vue&type=script&lang=js&"
export * from "./ChatImage.vue?vue&type=script&lang=js&"
import style0 from "./ChatImage.vue?vue&type=style&index=0&id=72791d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72791d0a",
  null
  
)

export default component.exports